import { render, staticRenderFns } from "./FormatUnderline.vue?vue&type=template&id=756c705a"
import script from "./FormatUnderline.vue?vue&type=script&lang=js"
export * from "./FormatUnderline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports